import styled from "styled-components";
import { useState, useEffect } from "react";
import useWallet from "../../../hooks/Wallet/useWallet";
import {  getRevenue } from "../../../api";
import CountUp from "react-countup";
import { FormattedMessage, useIntl } from "react-intl";
import usePersonSign from "../../../hooks/usePersonSign";
import ClaimConfrim from "./ClaimConfrim";
import {Modal} from "antd-mobile"
export default function Card2({onChange}) {
  const { myAccount } = useWallet();
  const {sendWithdraw} = usePersonSign()
  const intl = useIntl();
  const [nums, setNums] = useState({
    available: 0,
    total: 0,
    today: 0,
    yesterday: 0,
  });
  useEffect(() => {
    if (myAccount) {
      init()
    }
  }, [myAccount]);

  const init = () => {
    getRevenue({ addr: myAccount.account }).then((res) => {
      setNums(res.data);
    });
  }
  const claim = (available) => {
    const m = Modal.show({
      title: intl.formatMessage({
        id: "pages.account.profit_harvest_title",
        defaultMessage: "通知",
      }),
      bodyClassName: "runbit_modal",
      showCloseButton: true,
      actions: [
        {
          key: "prev",
          className: "border_btn",
          text: intl.formatMessage({
            id: "common.cancel",
            defaultMessage: "取消",
          }),
        },
        {
          key: "confrim",
          className: "primary_btn",
          text: intl.formatMessage({
            id: "common.confrim",
            defaultMessage: "確定",
          }),
          primary: true,
        },
      ],
      onAction: async (action, index) => {
        m.close();
        if (action.key === "confrim") {
          await sendWithdraw(available)
          init()
          onChange()
        }
      },
      closeOnAction: false,
      content: (
        <ClaimConfrim
          amount={available}
          time={'block2date(item.block)'}
          intl={intl}
        />
      ),
    });
  }
  return (
    <Wrapper>
      <div className="text1">
        <FormattedMessage id="可领取收益" />
        <img className="eye" src="image/icons/icon21.png" alt="" />
        <button
          className="btn"
          onClick={async () => {
            if (!myAccount) return;
            if (!nums.available) return;
            if (nums.available <= 0.8) return;
            claim(nums.available)
          }}
        >
          
          <FormattedMessage id="提币" />
        </button>
      </div>
      <div className="text2" style={{ margin: "1.5rem 0 3.0rem 0" }}>
        <CountUp
          end={nums.available}
          separator=","
          decimals={4}
          duration={0.5}
        />
        <span className="text1"> RT</span>
      </div>
      <div className="text1">
        <span><FormattedMessage id="昨日收益" /> </span>
        <span> {nums.yesterday.toFixed(4)}</span>
        <span style={{ margin: "0 1.0rem" }}> | </span>
        <span><FormattedMessage id="累计收益" /> </span>
        <span> {nums.total}</span>
      </div>
    </Wrapper>
  );
}
const Wrapper = styled.div`
  background: #3bada4;
  border-radius: 1.0rem;
  padding: 2.0rem 3.0rem;
  .text1 {
    font-weight: 400;
    font-size: 1.2rem;
    line-height: 1.2rem;

    color: #ffffff;
  }
  .text2 {
    font-weight: 600;
    font-size: 2.4rem;

    color: #ffffff;
  }
  .btn {
    border: none;
    outline: none;
    background: #ffe8da;
    border-radius: 4px;
    float: right;
    font-weight: 400;
    font-size: 1.2rem;
    line-height: 1.2rem;
    padding: .5rem 1.2rem;
    color: #000000;
  }
  .eye {
    width: 1.2rem;
    height: .8rem;
    margin-left: .6rem;
  }
`;
